module.exports = __webpack_public_path__ + "static/img/图层17.a64a356.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层17.png
// module id = kgcz
// module chunks = 0